module.exports = "<p>You do not have the appropriate permissions to view this page. Please contact your account management team.</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/no-access/no-access.component.html
// module id = ./src/app/components/no-access/no-access.component.html
// module chunks = main